(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kith-drops"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kith-countdown')) {
    class KithCountdown extends HTMLElement {
      connectedCallback() {
        const launch = this.getAttribute('data-launch');
        this.target = launch ? new Date(launch).getTime() : NaN;
        this.units = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };
        // The CTA can live in this element's parent (.kith-drop__content)
        const root = this.closest('.kith-drop') || this.parentElement || document;
        this.cta = root.querySelector('[data-countdown-cta]');

        if (Number.isNaN(this.target)) {
          this.goLive();
          return;
        }

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      tick() {
        const diff = this.target - Date.now();
        if (diff <= 0) {
          this.goLive();
          return;
        }
        const s = Math.floor(diff / 1000);
        this.set('days', Math.floor(s / 86400));
        this.set('hours', Math.floor((s % 86400) / 3600));
        this.set('minutes', Math.floor((s % 3600) / 60));
        this.set('seconds', s % 60);
      }

      set(unit, value) {
        const el = this.units[unit];
        if (el) el.textContent = String(value).padStart(2, '0');
      }

      goLive() {
        if (this.timer) clearInterval(this.timer);
        this.setAttribute('data-state', 'live');
        if (this.cta) {
          const live = this.cta.getAttribute('data-label-live');
          if (live) this.cta.textContent = live;
        }
      }
    }
    customElements.define('kith-countdown', KithCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
